import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const initTempDashboard = tempDashboardId => ({
  type: types.INIT_TEMP_DASHBOARD,
  tempDashboardId,
});

export const startFetching = () => ({
  type: types.START_FETCHING,
});

export const endFetching = () => ({
  type: types.END_FETCHING,
});
